import { http } from '@/core/helpers/axiosHelper';

export class CommuterTrafficDistanceService {
   async getCommuterTrafficDistance(employee_address: string, work_address: string) {
      return await http
         .get(`/commuter-traffic-distance`, { params: { employee_address, work_address } })
         .then((response: any) => response.data);
   }
}
